import { useContext } from 'react';

import { PostComposerContext, type PostComposerContextType } from './composerContext';

export const usePostComposer = (): PostComposerContextType => {
  const context = useContext(PostComposerContext);
  if (!context) {
    throw new Error('usePostComposer must be used within a PostComposerContext.Provider');
  }
  return context;
};
